<template>
  <span
    :aria-hidden="decorative"
    :aria-label="title"
    class="v-icon mdi theme--light text--text add-leak"
    role="img"
  >
    <svg
      :fill="fillColor"
      class="icon__svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <path
        d="m24.559 20.094v4.4647h-4.4647v2.9765h4.4647v4.4647h2.9765v-4.4647h4.4647v-2.9765h-4.4647v-4.4647z"
      />
      <path
        d="m1 6v12h3v-3h9l3-3-3-3h-9v-3h-3m27 0v3h-12l3 3-3 3h12v3h3v-12h-3m-12 12s-3 3.255-3 5.25a3 3 0 0 0 3 3 3 3 0 0 0 3-3c0-1.995-3-5.25-3-5.25z"
      />
      <title>{{ title }}</title>
    </svg>
  </span>
</template>

<script>
export default {
  name: "AddLeak",
  props: {
    title: {
      type: String,
      default: "Add leak"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>
<style scoped>
.icon__svg {
  height: 1em;
  width: 1em;
  position: absolute;
  bottom: -0.125em;
}

.v-icon.mdi.theme--light.text--text.add-leak {
  height: 1.25rem;
  font-size: 24px;
}
</style>
